import Vue from 'vue'
import PageContainer from './page-container'
import PageHeader from './page-header'
import PageButton from './page-button'
import PageScroll from './scroll'

const components = [PageContainer, PageHeader, PageScroll, PageButton]

components.forEach((item) => {
  Vue.component(item.name, item)
})



// WEBPACK FOOTER //
// ./src/components/index.js